<script setup>
import { useStoreGetters, useStore } from 'dashboard/composables/store';
import { computed, onMounted } from 'vue';
import { useBranding } from 'shared/composables/useBranding';
import { frontendURL } from 'dashboard/helper/URLHelper';
import IntegrationItem from './IntegrationItem.vue';
import SettingsLayout from '../SettingsLayout.vue';
import BaseSettingsHeader from '../components/BaseSettingsHeader.vue';

const store = useStore();
const getters = useStoreGetters();
const { replaceInstallationName } = useBranding();

const uiFlags = getters['integrations/getUIFlags'];

const integrationList = computed(
  () => getters['integrations/getAppIntegrations'].value
);

const accountId = getters.getCurrentAccountId;
const sicSupportURL = computed(() =>
  frontendURL(`accounts/${accountId.value}/settings/integrations/sic_support`)
);

onMounted(() => {
  store.dispatch('integrations/get');
});
</script>

<template>
  <SettingsLayout
    :is-loading="uiFlags.isFetching"
    :loading-message="$t('INTEGRATION_SETTINGS.LOADING')"
  >
    <template #header>
      <BaseSettingsHeader
        :title="$t('INTEGRATION_SETTINGS.HEADER')"
        :description="
          replaceInstallationName($t('INTEGRATION_SETTINGS.DESCRIPTION'))
        "
        :link-text="$t('INTEGRATION_SETTINGS.LEARN_MORE')"
        feature-name="integrations"
      />
    </template>
    <template #body>
      <div class="flex-grow flex-shrink overflow-auto">
        <div class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          <IntegrationItem
            v-for="item in integrationList"
            :id="item.id"
            :key="item.id"
            :logo="item.logo"
            :name="item.name"
            :description="item.description"
            :enabled="item.enabled"
          />

          <!-- Suporte IA card -->
          <div
            class="flex flex-col flex-1 p-6 m-[1px] outline outline-n-container outline-1 bg-n-alpha-3 rounded-md shadow"
          >
            <div class="flex items-start justify-between mb-4">
              <div
                class="flex h-12 w-12 items-center justify-center rounded-md bg-woot-500/10"
              >
                <span class="i-lucide-circle-help w-7 h-7 text-woot-500" />
              </div>
            </div>
            <div class="flex flex-col m-0 flex-1">
              <div
                class="font-medium mb-2 text-n-slate-12 flex justify-between items-center"
              >
                <span class="text-base font-semibold">Suporte IA</span>
                <router-link :to="sicSupportURL">
                  <span
                    class="text-sm text-woot-500 hover:text-woot-600 cursor-pointer"
                    >Configurar</span>
                </router-link>
              </div>
              <p class="text-n-slate-11 text-sm">
                Assistente de suporte interno do SIC. Gerencie a base de
                conhecimento do chat de suporte.
              </p>
            </div>
          </div>
        </div>
      </div>
    </template>
  </SettingsLayout>
</template>
